// src/components/Hero.js (added background image and CTA button)
import React from 'react';
import { FaCogs } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative bg-blue-600 text-white py-20 bg-cover bg-center" 
      style={{backgroundImage: 'url(https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&q=80)'}}>
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="relative max-w-7xl mx-auto px-4 text-center z-10">
        <FaCogs className="text-5xl mx-auto mb-6 animate-spin-slow" />
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          AI Workflow Designer Console
        </h1>
        <p className="text-xl md:text-2xl mb-8">
          No-Code Bot Management for Intelligent Customer Engagement
        </p>
        <p className="max-w-3xl mx-auto mb-8">
          A scalable SaaS platform by ENS Enterprises that empowers businesses 
          with real-time bot customization across WhatsApp, Web, and Mobile Apps
        </p>
        <Link to="http://stage.myindiabazar.com:3013/">
        <button className="bg-white text-blue-600 px-6 py-3 rounded-full font-semibold hover:bg-blue-100 transition">
          Get Started
        </button>
        </Link>
      </div>
    </section>
  );
};

export default Hero;